import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { getProductDetails } from './BundleCommonSelector';
import { selectedProductsForBundles } from './BundleProductOptionsSelector';

const getColorSwatches = (state) => state.colorSwatches;
const getProductImagesAndVideos = createSelector(
    [getProductDetails, getColorSwatches, selectedProductsForBundles, (_, id) => id],
    (productDetails = {}, colorSwatches = {}, bundleProducts, id) => {
        let bundleImageAndVideo = {};
        const bundleChildProducts = get(productDetails, 'products', []);
        /* istanbul ignore else */
        if (bundleChildProducts && bundleChildProducts.length) {
            bundleChildProducts.forEach((bundleProduct) => {
                let productChildVideos = [];
                const buildProductId = get(bundleProduct, 'product.id', ''); // reading id bundleProduct.product.id
                let productChildImages = get(bundleProducts[buildProductId], 'productImages', []);
                /* istanbul ignore next */
                if (!productChildImages.length) {
                    productChildImages = get(bundleProduct, 'product.images', []);
                }
                const productVideos = bundleProduct.product && bundleProduct.product.videos;
                if (productVideos && productVideos.length) {
                    productChildVideos = filter(productVideos, (video) => { // eslint-disable-line
                        /* istanbul ignore next */
                        if (video.type !== 'Scene7' && !includes(video.url, 'webcollage')) {
                            return false;
                        }
                        /* istanbul ignore next */
                        return productVideos.map((videos) => {
                            video.key = videos.url;
                            video.isVideo = true;
                            video.icon = 'play';
                            return video;
                        });
                    });
                }
                /* istanbul ignore next */
                if (
                    colorSwatches.ppId &&
                    colorSwatches.ppId === buildProductId &&
                    colorSwatches.primaryImage &&
                    productChildImages.length
                ) {
                    productChildImages = [colorSwatches.primaryImage].concat(
                        productChildImages.slice(1)
                    );
                }
                bundleImageAndVideo = {
                    ...bundleImageAndVideo,
                    [buildProductId]: {
                        productChildItems: [...productChildImages, ...productChildVideos],
                    },
                };
                return bundleImageAndVideo;
            });
        }

        return bundleImageAndVideo[id];
    }
);

export default getProductImagesAndVideos;
